"use client"

import { useSearchParams, useRouter, usePathname } from "next/navigation"
import { SlidersHorizontal } from "lucide-react"
import { cn } from "@/core/lib/utils"
import { getOptions } from "@/constants/options"
import { useDictionary } from "@/core/hooks/use-dictionary"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type SortOption = "" | "popular" | "cheapest" | "expensive" | "oldest"

export function ProductSortSidebar() {
    const searchParams = useSearchParams()
    const router = useRouter()
    const pathname = usePathname()
    const { dictionary } = useDictionary();

    const { SORT_OPTIONS } = getOptions(dictionary);


    const currentValue = (searchParams.get("sort_by") as SortOption) || ""
    const currentLabel = SORT_OPTIONS.find((opt) => opt.value === currentValue)?.label
    const updateSort = (value: SortOption) => {
        const params = new URLSearchParams(searchParams.toString())
        value === "" ? params.delete("sort_by") : params.set("sort_by", value)
        router.push(`${pathname}?${params}`)
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <div className="flex items-center text-sm">
                    <SlidersHorizontal className="ml-2 h-3.5 w-3.5" />
                    {currentLabel}
                </div>
            </DropdownMenuTrigger>

            <DropdownMenuContent
                align="end"
                sideOffset={6}
                className="w-36 text-sm shadow-none border border-gray-200 rounded-none"
            >
                <div className="space-y-5 p-4">
                    {SORT_OPTIONS.map((option) => {
                        const isSelected = currentValue === option.value
                        return (
                            <div
                                key={option.value}
                                onClick={() => updateSort(option.value)}
                                onPointerDown={(e) => e.stopPropagation()}
                                className={cn("flex items-center justify-end gap-3 cursor-pointer select-none")}
                            >
                                <div className={cn("text-sm text-right pb-1", isSelected ? "border-b border-b-primary-900" : "")}>{option.label}</div>
                            </div>
                        )
                    })}
                </div>


            </DropdownMenuContent>
        </DropdownMenu >

    )
}
